import * as yup from "yup";

export const DiscussionAndNoteFormValidator = yup.object().shape({
  name: yup.string().required("Name Error"),
  body: yup.string(),
  is_hidden_from_clients: yup.boolean(),
  is_pinned: yup.boolean(),
});
